import "date-fns";
import React, { useState, useEffect } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import { es } from "date-fns/locale";

//usar forwardRef ?
const DatePickerCustom = ({
  fullWidth,
  onChange,
  onKeyDown,
  value,
  minDate,
  maxDate,
  className,
  label,
  id,
  error,
  onBlur,
  reference,
  readOnly = false,
  required,
  invalidDateMessage,
  sx,
}) => {
  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = useState(value);
  const [dateError, setDateError] = useState(null);
  const [touched, setTouched] = useState(false);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (onChange) onChange(date);
  };

  const handleBlur = () => {
    setTouched(true);
    if (onBlur) onBlur();
  };

  useEffect(() => {
    setSelectedDate(value);
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
      <DatePicker
        label={label}
        value={selectedDate}
        onChange={handleDateChange}
        minDate={minDate}
        maxDate={maxDate}
        onError={(reason) => setDateError(reason)}
        renderInput={(params) => {
          const hasInvalidDate =
            Boolean(invalidDateMessage) && Boolean(dateError) && touched;
          return (
            <TextField
              {...params}
              variant="standard"
              fullWidth={fullWidth}
              margin="normal"
              id={id}
              error={error || hasInvalidDate}
              helperText={hasInvalidDate ? invalidDateMessage : undefined}
              onBlur={handleBlur}
              onKeyDown={onKeyDown}
              required={required}
              autoComplete="off"
              name={`datepicker-${id || "nohistory"}`}
              sx={{
                "& .MuiInputAdornment-root": {
                  marginRight: "15px",
                },
                ...sx,
              }}
              inputProps={{
                ...params.inputProps,
                autoComplete: "new-password",
                autoCorrect: "off",
                spellCheck: false,
                inputMode: "numeric",
                pattern: "\\d*",
                readOnly: readOnly,
              }}
            />
          );
        }}
        PopoverProps={{
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePickerCustom;
